import { useRef } from "react"

const CommunityFooter = ({total, filter, setfilter, last_page,current_page}) => {
    const secondPg = useRef(null);
    return (
        <>
            <span class="result-foot">{total} results</span>
            {
                filter?.page && (
                    <div class="table-pagination pagebtn-u">
                        <button className={`btn nextprvbtn ${current_page == 1 ? 'btn-disabeled' : '' }`} onClick={() => setfilter({ ...filter, page: filter?.page - 1 })} disabled={current_page == 1 ? true : false }>Previous</button>

                        {filter?.page !== 1 && <button onClick={() => setfilter({ ...filter, page: filter?.page - 1 })} class="btn btn-light btn-sm 1">{filter?.page - 1}</button>}

                        <button onClick={() => setfilter({ ...filter, page: filter?.page })} class="btn btn-light btn-sm active 2">{filter?.page}</button>

                        <button ref={secondPg} onClick={() => setfilter({ ...filter, page: filter?.page + 1 })} class="btn btn-light btn-sm 3" disabled={filter?.page == last_page}>{filter?.page + 1}</button>

                        {filter?.page == 1 && <button onClick={() => setfilter({ ...filter, page: filter?.page + 2 })} disabled={filter?.page == last_page} class="btn btn-light btn-sm 4">{filter?.page + 2}</button>}

                        <button ref={secondPg} onClick={() => setfilter({ ...filter, page: filter?.page + 1 })} disabled={filter?.page == last_page} className={`btn nextprvbtn ${filter?.page == last_page ? 'btn-disabeled' : '' }`}>Next</button>
                    </div>

                )
            }
        </>
    )
}
export default CommunityFooter